import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, string } from "yup";
import PURCHASEIRQPrimaryResidenceView from "../views/IrqPrimaryResidenceView";
import StatusCheck from "../components/StatusCheck";

class BuildIrqPrimaryResidencePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            occupancyType: string().required(),
          })}
        >
          <PURCHASEIRQPrimaryResidenceView
            content={contentMap.BuildIrqPrimaryResidencePage}
            navigationsAway={customNavigationMap.BuildIrqPrimaryResidencePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqPrimaryResidencePage);
